import { Trans, useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { StringText } from '@/Atomic/Atoms/StringText'
import { Button } from '@/Atomic/Molecules/Button'
import InfoBox from '@/Atomic/Molecules/InfoBox'
import { Modal } from '@/Atomic/Organisms/Modal'
import { useModalHandler } from '@/hooks/useModalHandler'

import './DeleteAddressModal.scss'

export const DeleteAddressModal: React.FC<{
  isOpen: boolean
  close: () => void
  confirm: () => void
  addressType: string
}> = ({ isOpen, close, confirm, addressType }) => {
  const { t } = useTranslation()

  return (
    <Modal
      onClose={close}
      isOpen={isOpen}
      variant="danger"
      className="delete-address-modal"
    >
      <Modal.Header title={t('common.delete')} />
      <Modal.Body className="delete-modal-body">
        <StringText>
          <Trans
            i18nKey="components.address.deleteFor"
            values={{ addressType }}
            components={{ b: <b /> }}
          />
        </StringText>
        <InfoBox type="danger" text={t('components.address.deleteInfo')} />
      </Modal.Body>
      <Modal.Footer
        onCancel={close}
        onCancelText={t('common.cancel')}
        onConfirm={confirm}
        onConfirmText={t('common.delete')}
      />
    </Modal>
  )
}

export const DeleteAddressConnectionButton: React.FC<{
  relation: DataItem
  addressType: string
}> = ({ relation, addressType }) => {
  const { t } = useTranslation()
  const { isOpen, closeModal, openModal } = useModalHandler()

  return (
    <>
      <Button
        className="delete-address-button"
        variant="icon"
        icon="bin"
        tooltip={t('common.delete')}
        onClick={openModal}
      />
      <DeleteAddressModal
        isOpen={isOpen}
        close={closeModal}
        confirm={() => relation.delete()}
        addressType={addressType}
      />
    </>
  )
}
